var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3954;}\n\t.st1{fill:#16ADE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.2,85.4h-45.3v34.5c0,23.8-19.4,43.1-43.1,43.1h-85.4c-23.8,0-43.1-19.4-43.1-43.1V85.4h-45.3    c-13.2,0-23.8,10.7-23.8,23.8v349.1c0,13.2,10.7,23.8,23.8,23.8h262.3c13.2,0,23.8-10.7,23.8-23.8V109.2    C411,96.1,400.3,85.4,387.2,85.4z M360.9,448.7H342v-39.7c0-3.9-3.1-7-7-7s-7,3.1-7,7v39.7H151.1v-95.2c0,0,0,0,0,0h61.6    c2.4,0,4.6-1.2,5.9-3.3l23.3-37v92.4c0,3.1,2,5.8,5,6.7c0.7,0.2,1.4,0.3,2,0.3c2.3,0,4.5-1.1,5.8-3.1l42.9-64.2h63.2c0,0,0,0,0,0    V448.7z M360.9,331.4C360.9,331.4,360.9,331.4,360.9,331.4h-67c-2.3,0-4.5,1.2-5.8,3.1l-32.2,48.1V289c0-3.1-2.1-5.9-5.1-6.7    c-3-0.9-6.2,0.4-7.9,3l-34.1,54.2h-57.7c0,0,0,0,0,0v-91.8h209.7V331.4z M360.9,220H151.1v-31.8h209.7V220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.4,384.6c-0.2-0.4-0.4-0.8-0.6-1.2c-0.3-0.4-0.5-0.7-0.9-1.1c-0.3-0.3-0.7-0.6-1.1-0.9    c-0.4-0.3-0.8-0.5-1.2-0.7c-0.4-0.2-0.9-0.3-1.3-0.4c-0.9-0.2-1.8-0.2-2.7,0c-0.4,0.1-0.9,0.2-1.3,0.4c-0.4,0.2-0.8,0.4-1.2,0.7    c-0.4,0.3-0.8,0.5-1.1,0.9c-0.3,0.3-0.6,0.7-0.9,1.1c-0.3,0.4-0.5,0.8-0.6,1.2c-0.2,0.4-0.3,0.9-0.4,1.3c-0.1,0.5-0.1,0.9-0.1,1.4    c0,1.8,0.8,3.6,2,4.9c0.3,0.3,0.7,0.6,1.1,0.9c0.4,0.3,0.8,0.5,1.2,0.6c0.4,0.2,0.9,0.3,1.3,0.4c0.5,0.1,0.9,0.1,1.4,0.1    c0.5,0,0.9,0,1.4-0.1c0.5-0.1,0.9-0.2,1.3-0.4c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.3,0.7-0.5,1.1-0.9c1.3-1.3,2.1-3.1,2.1-4.9    c0-0.5,0-0.9-0.1-1.4C341.8,385.5,341.6,385,341.4,384.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.3,136.6h85.4c9.2,0,16.7-7.5,16.7-16.7V85.4H289V62.8c0-18.2-14.8-33-33-33s-33,14.8-33,33v22.6h-26.5     v34.5C196.5,129.1,204,136.6,213.3,136.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecord);
export default __webpack_public_path__ + "static/media/medical_record.e8c5dd4c35de16ed17f59b605b57d215.svg";
export { ForwardRef as ReactComponent };